import { faThumbsDown, faThumbsUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MDSpinner from "react-md-spinner";
import MessageMp3Player from "./MessageMp3Player";
import { useContext, useState } from "react";
import { AppContext } from "../../../../../../Util/contexts/AppContext";

/*
  stateOptions = {
    userMessage: ["audioUnprocessed", "completed"],
    systemMessage: ["generatingResponse", "generatingAudio", "completed"],
  };
*/

const ChatMessage = ({
  message,
  isUserMessage,
  state,
  mp3FileUrl,
  id,
  audioControlsEnabled,
  showTranscriptions,
  ExamAttemptId,
  textHidden,
}) => {
  let feedbackSection = null;
  const { route, displayAuthenticationError, userData } =
    useContext(AppContext);
  const [feedback, setFeedback] = useState(null);

  const fetchHandleFeedback = async (isPositive) => {
    await fetch(`${route}/speakingfeedback.webapi`, {
      method: "POST",
      headers: {
        Token: userData.Token,
        "Content-Type": "text/plain",
      },
      body: JSON.stringify({
        exam_attempt_id: ExamAttemptId,
        content: message,
        thumbsUp: isPositive,
        thumbsDown: !isPositive,
      }),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 401) {
          displayAuthenticationError();
          throw new Error("User is no longer authenticated");
        } else {
          throw new Error("Error fetching transcription");
        }
      })
      .then((result) => {
        setFeedback(isPositive ? "positive" : "negative");
      })
      .catch((error) => {
        console.error("Error handling feedback:", error);
      });
  };

  if (state !== "audioUnprocessed" && state !== "generatingResponse") {
    feedbackSection = (
      <div className="chatHistoryMessageToolbar">
        <button
          title={
            isUserMessage
              ? "My recording was transcribed accurately"
              : "This response is relevant to my last message"
          }
          onClick={() => fetchHandleFeedback(true)}
          disabled={feedback === "positive"}
        >
          <FontAwesomeIcon icon={faThumbsUp} />
        </button>
        <button
          title={
            isUserMessage
              ? "My recording was not transcribed accurately"
              : "This response is not relevant to my last message"
          }
          onClick={() => fetchHandleFeedback(false)}
          disabled={feedback === "negative"}
        >
          <FontAwesomeIcon icon={faThumbsDown} />
        </button>
      </div>
    );
  }

  let transcriptionSection = null;
  console.log(state, message);
  if (state === "audioUnprocessed" && isUserMessage) {
    transcriptionSection = (
      <div className="chatHistoryTranscriptionLoadingWrapper">
        <MDSpinner singleColor="white" size={16} />
        <p>Loading Transcription...</p>
      </div>
    );
  } else {
    transcriptionSection = <p>{message}</p>;
  }

  if (state === "generatingResponse" && textHidden) {
    transcriptionSection = <>Generating response...</>;
  } else if (state === "generatingAudio" && textHidden) {
    transcriptionSection = <>Generating response...</>;
  } else if (state === "completed" && textHidden) {
    transcriptionSection = <>Response Generated...</>;
  }

  if (!showTranscriptions) {
    transcriptionSection = null;
    feedbackSection = null;
  }

  let audioSection = null;

  if (state === "generatingAudio" && !isUserMessage) {
    audioSection = (
      <div className="chatHistoryAudioLoadingWrapper">
        <MDSpinner singleColor="#0283be" size={16} />
        <p>Generating Audio Response...</p>
      </div>
    );
  } else if (state === "generatingResponse" && !isUserMessage) {
    audioSection = null;
    if (!showTranscriptions) {
      return null;
    }
  } else {
    audioSection = (
      <MessageMp3Player
        mp3Id={id}
        mp3FileUrl={mp3FileUrl}
        audioControlsDisabled={!audioControlsEnabled}
        showTopBorder={showTranscriptions}
      />
    );
  }

  return (
    <div
      className={
        isUserMessage ? `chatHistoryUserMessage` : "chatHistorySystemMessage"
      }
    >
      {feedbackSection}
      {transcriptionSection}
      {audioSection}
    </div>
  );
};

export default ChatMessage;
